import { render, staticRenderFns } from "./EcomButton.vue?vue&type=template&id=76b632df"
import script from "./EcomButton.vue?vue&type=script&lang=js"
export * from "./EcomButton.vue?vue&type=script&lang=js"
import style0 from "./EcomButton.vue?vue&type=style&index=0&id=76b632df&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports